import { CategoryInfo } from "@/model/CategoryInfo";
import { createStore } from "vuex";

const store = createStore({
  state: {
    status: "",
    maxHeight: 430,
    localLanguage: "zh-cn",
  },
  mutations: {
    carStatus(state: any, val: string) {
      state.status = val;
    },
    setLocalLanguage(state: any, val: string) {
      state.localLanguage = val;
    },
    setMaxHeight(state: any, val: number) {
      state.maxHeight = val;
    },
  },
  actions: {},
  getters: {
    getCarStatus(state: any) {
      return state.status;
    },
    getMaxHeight(state: any) {
      return state.maxHeight;
    },
    getLocalLanguage(state: any) {
      return state.localLanguage;
    },
  },
  modules: {},
});

export default store;
